import { render } from "./ConfirmDelete.vue?vue&type=template&id=1a55ed43"
import script from "./ConfirmDelete.vue?vue&type=script&lang=js"
export * from "./ConfirmDelete.vue?vue&type=script&lang=js"

import "./ConfirmDelete.vue?vue&type=style&index=0&id=1a55ed43&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__